export const GET_PROVINCE_LIST = 'GET_PROVINCE_LIST';
export const GET_PROVINCE_LIST_SUCCESS = 'GET_PROVINCE_LIST_SUCCESS';
export const GET_PROVINCE_LIST_FAILED = 'GET_PROVINCE_LIST_FAILED';

export const GET_DISTRICT_LIST = 'GET_DISTRICT_LIST';
export const GET_DISTRICT_LIST_SUCCESS = 'GET_DISTRICT_LIST_SUCCESS';
export const GET_DISTRICT_LIST_FAILED = 'GET_DISTRICT_LIST_FAILED';

export const GET_WARD_LIST = 'GET_WARD_LIST';
export const GET_WARD_LIST_SUCCESS = 'GET_WARD_LIST_SUCCESS';
export const GET_WARD_LIST_FAILED = 'GET_WARD_LIST_FAILED';
